import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import Panel from '@/components/Panel';
import { resetComponent, setOperate } from '@/slices/execComponentSlice';
import SelectCluster from './SelectCluster';
import BasicInfo from './BasicInfo';
import ChoiceLib from './ChoiceLib';
import ChoiceHost from './ChoiceHost';
import Config from './Config';

export const OPERATE = {
  DEPLOY: 'DEPLOY',
  UPGRADE: 'UPGRADE',
};

function ExecuteComponentDetail({ resetComponent, setOperate }) {
  const [searchParams] = useSearchParams();
  const [step, setStep] = useState(0);

  const id = searchParams.get('id');

  useEffect(() => {
    return () => {
      resetComponent();
    };
  }, [resetComponent, id]);

  const doNextStep = (val) => {
    setOperate(val);
    setStep(1);
  };

  return (
    <Root>
      {step === 0 && (
        <Panel style={{ marginRight: 20 }}>
          <SelectCluster>
            <BasicInfo />
          </SelectCluster>
          <ChoiceLib />
          <ChoiceHost doNextStep={doNextStep} />
        </Panel>
      )}
      {step === 1 && <Config />}
    </Root>
  );
}

export default connect(null, {
  resetComponent,
  setOperate,
})(ExecuteComponentDetail);

const Root = styled.div`
  flex: 0;
  min-width: 800px;
`;
